export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export function formatDate(currentLanguage, date, showWeekday = false) {
    return formatDateAndTime(date, currentLanguage, showWeekday, false);
}

export function formatDateAndTime(date, currentLanguage = 'en-US', showWeekday = false, showTime = true) {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };

    if (showTime) {
        options['hour'] = 'numeric';
        options['minute'] = 'numeric';
    }

    if (showWeekday) {
        options['weekday'] = 'short';
    }

    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    return date.toLocaleDateString(currentLanguage, options);
}

export function getCurrentMonday() {
    let currentMonday = new Date(Date.now());

    // Go to monday if now is a sunday.
    if (currentMonday.getDay() !== 0) {
        currentMonday = new Date(currentMonday.getTime() + DAY_IN_MILLISECONDS);
    }

    // Go to monday if now is a saturday.
    if (currentMonday.getDay() !== 6) {
        currentMonday = new Date(currentMonday.getTime() + 2 * DAY_IN_MILLISECONDS);
    }

    while (currentMonday.getDay() !== 1) {
        currentMonday = new Date(currentMonday.getTime() - DAY_IN_MILLISECONDS);
    }

    return currentMonday;
}

export function getToday() {
    const today = new Date(Date.now());
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    return today;
}

export function compareDate(day1, day2) {
    day1.setHours(0);
    day1.setMinutes(0);
    day1.setSeconds(0);
    day1.setMilliseconds(0);

    day2.setHours(0);
    day2.setMinutes(0);
    day2.setSeconds(0);
    day2.setMilliseconds(0);

    return day1.getTime() - day2.getTime() >= 0;
}

/**
 * example of ISO-Date-String: 2020-10-30
 * @param date
 * @returns {string}
 */
export function convertDateToIsoDateString(date) {
    const tzoffset = (date).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);
    return localISOTime.split('T')[0];
}

export function getNextDayAt(hour, minute, second) {
    const today = getToday();
    today.setHours(hour);
    today.setMinutes(minute);
    today.setSeconds(second);
    today.setMilliseconds(0);
    return addDays(today, 1);
}

export function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function minusDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
}
